document.addEventListener('DOMContentLoaded', function() {
  var hash = window.location.hash;

  const urlParams = new URLSearchParams(window.location.search);
  const type = urlParams.get('type');

  if (hash === "#created-invoice") {
    history.replaceState(null, null, ' ');
    window.scrollTo(0, 0);
    $('#created_invoice_tab').click();
  }

  if (hash === "#payment-archive") {
    history.replaceState(null, null, ' ');
    window.scrollTo(0, 0);
    $('#payment_archive_tab').click();
  }

  if ((hash === '#paid-invoice') || (type == 'success')) {
    history.replaceState(null, null, ' ');
    window.scrollTo(0, 0);
    $('#paid_invoice_tab').click();
  }

  if (hash === '#cancelled-invoice') {
    history.replaceState(null, null, ' ');
    window.scrollTo(0, 0);
    $('#cancelled_invoice_tab').click();
  }

  if (hash === '#accounted') {
    history.replaceState(null, null, ' ');
    window.scrollTo(0, 0);
    $('#accounted_tab').click();
  }
});

$(document).ready(function(){

  $(document).on('click', '#payment_archive_tab, #accounted_tab, #ad_content_changes_to_be_approved_tab, #created_invoice_tab, #cancelled_invoice_tab, #open_invoices_tab, #paid_invoice_tab, #cancelled_invoice_tab, #open_and_sent_invoices_tab',  function() {
    first_pagination();
    second_pagination();
    third_pagination();
  });

  $('#manage_invoice_status').on('change', function() {
    var invoice_status = $(this).is(':checked');
    var invoice_id = $("#aggregated_invoice_id").val();
    $.ajax({
      url: '/invoices/' + invoice_id + '/update_invoice_status',
      type: 'PUT',
      data: { status: invoice_status}
    });
  });

  $('.seller_user_type').on('click', function() {
    var seller_user_type = $(this).val();
    if (seller_user_type == 'TRUSTED_SELLER'){
      $('#paytrail_service_info').removeClass('hide');
      $('.seller_paytrail_merchant_id').addClass('mandatory_field');
      $('.seller_security_key').addClass('mandatory_field');
    } else {
      $('#paytrail_service_info').addClass('hide');
      $('.seller_paytrail_merchant_id').removeClass('mandatory_field');
      $('.seller_security_key').removeClass('mandatory_field');
    }
  });


  $('#user_has_paytrail_service').on('change', function() {
    var checked = $(this).is(':checked');
    if (checked){
      $('#paytrail_service_info').removeClass('hide');
      $('.seller_paytrail_merchant_id').addClass('mandatory_field');
      $('.seller_security_key').addClass('mandatory_field');
    } else {
      $('#paytrail_service_info').addClass('hide');
      $('.seller_paytrail_merchant_id').removeClass('mandatory_field');
      $('.seller_security_key').removeClass('mandatory_field');
    }
  });

  $(document).on("click", "#confirm_all_open_invoices", function() {
    var checked = $(this).prop('checked');
    if (checked){
      $('.confirm_open_invoice').prop('checked', true);
      $('.select_all_invoice_text').addClass('hide');
      $('.unselect_all_invoice_text').removeClass('hide');
      $('.send_invoice_list').removeClass('disableattchmentbutton');
      $('.create_bulk_invoice').removeClass('disableattchmentbutton');
    } else {
      $('.confirm_open_invoice').prop('checked', false);
      $('.select_all_invoice_text').removeClass('hide');
      $('.unselect_all_invoice_text').addClass('hide');
      $('.send_invoice_list').addClass('disableattchmentbutton');
      $('.create_bulk_invoice').addClass('disableattchmentbutton');
    }
    var total = 0;
    $('.invoice_value_with_vat').each(function(){
       total += checkNumericValue($(this).val());
    });
    $('.selected_invoice_total').text(show_formatted_number(total));
    $('#aggregated_invoices_total').val(show_formatted_number(total));
  });

  $(document).on("click",".confirm_open_invoice", function() {
    var checked = $(this).prop('checked');
    $(this).prop('checked', checked);
    if (checked){
      $('.send_invoice_list').removeClass('disableattchmentbutton');
      $('.create_bulk_invoice').removeClass('disableattchmentbutton');
    } else{
      $('.send_invoice_list').addClass('disableattchmentbutton');
      $('.create_bulk_invoice').addClass('disableattchmentbutton');
    }
    var total = 0;
    $('.confirm_open_invoice').each(function(){
      var id = getId(this.id);
      var checked = $("#confirm_open_invoice_"+id).prop('checked');
      if(checked){
        total += checkNumericValue($("#invoice_value_with_vat_"+id).val());
      }
    });
    $('.selected_invoice_total').text(show_formatted_number(total));
    $('#aggregated_invoices_total').val(show_formatted_number(total));
  });

  $(document).on("click",".send_invoice_list", function() {
    var seller_id = $("#seller_id").val();
    var user_role = $("#user_role").val();
    var invoice_ids = new Array();
    $("input:checkbox[name=confirm_open_invoice]:checked").each(function(){
      var checked = $(this).prop('checked');
      if (checked){
        invoice_ids.push(getId(this.id));
      }
    });
    $.ajax({
      url: '/invoices/' + seller_id + '/send_invoice_list',
      type: 'GET',
      data: { invoice_ids: invoice_ids, user_role: user_role }
    });
  });

  $(document).on("click",".create_bulk_invoice", function() {
    var seller_id = $("#seller_id").val();
    var amount = $('#aggregated_invoices_total').val();
    var invoice_ids = new Array();
    $("input:checkbox[name=confirm_open_invoice]:checked").each(function(){
      var checked = $(this).prop('checked');
      if (checked){
        invoice_ids.push(getId(this.id));
      }
    });
    $.ajax({
      url: '/invoices/' + seller_id + '/create_invoice',
      type: 'POST',
      data: { invoice_ids: invoice_ids, amount: amount}
    });
  });

  // For main user
  $(document).on("click", ".confirm_open_invoice_for_main_user", function () {
    var total = 0;
    var invoice_ids = [];
    var auction_user_ids = new Set();

    // Loop through all checkboxes
    $(".confirm_open_invoice_for_main_user:checked").each(function () {
      var id = getId(this.id);
      invoice_ids.push(id);
      total += checkNumericValue($("#invoice_value_with_vat_for_main_user_" + id).val());

      var auction_user_id = $("#auction_user_id_" + id).val();
      auction_user_ids.add(auction_user_id);
    });

    // Update total value
    $(".selected_invoice_total_for_main_user").text(show_formatted_number(total));
    $("#aggregated_invoices_total_for_main_user").val(show_formatted_number(total));

    // Enable/Disable buttons
    if (invoice_ids.length === 0) {
      $(".send_invoice_list_for_main_user, .create_bulk_invoice_for_main_user").addClass("disableattchmentbutton");
      $("#create_invoice_flash_notice").html("");
    } else {
      $(".send_invoice_list_for_main_user, .create_bulk_invoice_for_main_user").removeClass("disableattchmentbutton");

      // Check if more than one auction_user is selected
      if (auction_user_ids.size > 1) {
        $("#create_invoice_flash_notice").html(
          "<div class='alert alert-warning alert-dismissible'>" +
            "Selection not possible. Two different customers. Go back and confirm the correct selection." +
            "<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button>" +
          "</div>"
        );
        $(".create_bulk_invoice_for_main_user").addClass("disableattchmentbutton");
        $(".send_invoice_list_for_main_user").addClass("disableattchmentbutton");
      } else {
        $("#create_invoice_flash_notice").html(""); // Remove warning if only one customer selected
      }
    }
  });

  $(document).on("click",".send_invoice_list_for_main_user", function() {
    var seller_id = $("#seller_id").val();
    var user_role = $("#user_role").val();
    var invoice_ids = new Array();
    $("input:checkbox[name=confirm_open_invoice_for_main_user]:checked").each(function(){
      var checked = $(this).prop('checked');
      if (checked){
        invoice_ids.push(getId(this.id));
      }
    });
    $.ajax({
      url: '/invoices/' + seller_id + '/send_invoice_list',
      type: 'GET',
      data: { invoice_ids: invoice_ids, user_role: user_role }
    });
  });

  $(document).on("click", ".create_bulk_invoice_for_main_user", function () {
    var seller_id = $("#seller_id").val();
    var amount = $('#aggregated_invoices_total_for_main_user').val();
    var invoice_ids = [];

    $("input:checkbox[name=confirm_open_invoice_for_main_user]:checked").each(function () {
      var id = getId(this.id);
      invoice_ids.push(id);
    });

    // Re-check just before submitting
    var auction_user_ids = new Set();
    invoice_ids.forEach(function(id) {
      var auction_user_id = $("#auction_user_id_" + id).val();
      auction_user_ids.add(auction_user_id);
    });

    if (auction_user_ids.size > 1) {
      $("#create_invoice_flash_notice").html("<div class='alert alert-warning alert-dismissible'>Selection not possible. Two different customers. Go back and confirm the correct selection.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>");
      $(".create_bulk_invoice_for_main_user").addClass("disableattchmentbutton");
      return;
    }

    $("#create_invoice_flash_notice").html("");

    $.ajax({
      url: '/invoices/' + seller_id + '/create_invoice',
      type: 'POST',
      data: { invoice_ids: invoice_ids, amount: amount }
    });
  });

  $(document).on("click", ".net_selling_price_edit", function(){
    var id = getId(this.id);
    $("#selling_price_with_vat").removeAttr('disabled');
    $("#net_selling_price_info_" + id).removeClass("hide");
  });

  $(document).on("click", ".cancel_invoice_button", function(){
    $(".cancel_invoice").addClass("hide");
    window.location.href = '/invoices/manage_invoices';
  });

  $(document).on("click", ".success_invoice_button", function(){
    $(".success_invoice").addClass("hide");
    window.location.href = '/invoices/manage_invoices';
  });

  $(document).on('keyup', '#selling_price_with_vat',  function() {
    var selling_price_with_vat = $("#selling_price_with_vat").val();
    var auction_vat_type = $("#selling_price_vat_rate").val();
    var vat_rate = $("#vat_rate").val();
    var online_auction_price_list_raw = $("#online_auction_price_list").val();
    if (auction_vat_type == "0,0"){
      var price_without_vat = checkNumericValue(selling_price_with_vat)
    }else{
      var price_without_vat = checkNumericValue(selling_price_with_vat) / (1 + (checkNumericValue(auction_vat_type) / 100))
    }
    var vat_price = checkNumericValue(selling_price_with_vat) - checkNumericValue(price_without_vat)
    $("#vat_value_with_perc").val(checkNumericValue(vat_price));
    $("#vat_free_selling_price").val(checkNumericValue(price_without_vat));

    if (online_auction_price_list_raw && online_auction_price_list_raw.trim() !== '') {
      try {
        var online_auction_price_list = JSON.parse(online_auction_price_list_raw);
        if (Array.isArray(online_auction_price_list) && online_auction_price_list.length > 0) {
          var ad_price_without_vat = adPriceWithoutVat(price_without_vat, online_auction_price_list);
          var ad_price_with_vat = checkNumericValue(ad_price_without_vat) * (1 + (checkNumericValue(vat_rate) / 100));

          $("#ad_price_without_vat").val(checkNumericValue(ad_price_without_vat));
          $("#ad_price_with_vat").val(checkNumericValue(ad_price_with_vat));
          var vat_price = checkNumericValue(ad_price_with_vat) - checkNumericValue(ad_price_without_vat)
          $("#ad_price_with_vat_value").val(checkNumericValue(vat_price));
        } else {
          $("#ad_price_without_vat").val(0);
          $("#ad_price_with_vat").val(0);
          $("#ad_price_with_vat_value").val(0);
        }
      } catch (e) {
        $("#ad_price_without_vat").val(0);
        $("#ad_price_with_vat").val(0);
        $("#ad_price_with_vat_value").val(0);
      }
    } else {
      $("#ad_price_without_vat").val(0);
      $("#ad_price_with_vat").val(0);
      $("#ad_price_with_vat_value").val(0);
    }
  });

  $(document).on('click', '.net_selling_price_save', function(){
    var id = getId(this.id);
    var selling_price_with_vat = $("#selling_price_with_vat").val();
    var ad_price_with_vat = $("#ad_price_with_vat").val();
    var type = $("#type").val();
    $.ajax({
      url: '/invoices/' + id + '/save_net_selling_price',
      type: 'PUT',
      data: { selling_price_with_vat: selling_price_with_vat, type: type, ad_price_with_vat: ad_price_with_vat}
    });
  });

  $(document).on("click", ".net_selling_price_cancel", function(){
    var id = getId(this.id);
    $("#net_selling_price_info_" + id).addClass('hide');
    $("#selling_price_with_vat").attr('disabled', 'disabled');
    $("#selling_price_with_vat").val($("#original_selling_price_with_vat").val());
  });


  //show category form on clicking edit btn
  $(document).on("click", ".ad_price_edit", function(){
    var id = getId(this.id);
    $("#ad_price_popup_" + id).removeClass('hide');
    $("#ad_price_without_vat").removeAttr('disabled');
    $("#vat_rate").removeAttr('disabled');
  });

  $(document).on('keyup', '#ad_price_without_vat',  function() {
    var ad_price_without_vat = $("#ad_price_without_vat").val();
    var auction_vat_type = $("#vat_rate").val();

    if (auction_vat_type == "0,0"){
      var ad_price_with_vat = checkNumericValue(ad_price_without_vat)
    }else{
      var ad_price_with_vat = checkNumericValue(ad_price_without_vat) * (1 + (checkNumericValue(auction_vat_type) / 100))
    }
    $("#ad_price_with_vat").val(checkNumericValue(ad_price_with_vat));
    var vat_price = checkNumericValue(ad_price_with_vat) - checkNumericValue(ad_price_without_vat)
    $("#ad_price_with_vat_value").val(checkNumericValue(vat_price));
  });

  $(document).on('change', '#vat_rate',  function() {
    var ad_price_without_vat = $("#ad_price_without_vat").val();
    var auction_vat_type = $("#vat_rate").val();

    if (auction_vat_type == "0,0"){
      var ad_price_with_vat = checkNumericValue(ad_price_without_vat)
    }else{
      var ad_price_with_vat = checkNumericValue(ad_price_without_vat) * (1 + (checkNumericValue(auction_vat_type) / 100))
    }
    $("#ad_price_with_vat").val(checkNumericValue(ad_price_with_vat));
    var vat_price = checkNumericValue(ad_price_with_vat) - checkNumericValue(ad_price_without_vat)
    $("#ad_price_with_vat_value").val(checkNumericValue(vat_price));
  });

  $(document).on('click', '.ad_price_save', function(){
    var id = getId(this.id);
    var ad_price_with_vat = $("#ad_price_with_vat").val();
    var ad_vat_rate = $("#vat_rate").val();
    var type = $("#type").val();
    $.ajax({
      url: '/invoices/' + id + '/save_net_selling_price',
      type: 'PUT',
      data: { ad_price_with_vat: ad_price_with_vat, ad_vat_rate: ad_vat_rate, type: type}
    });
  });

  $(document).on("click", ".ad_price_cancel", function(){
    var id = getId(this.id);
    $("#ad_price_popup_" + id).addClass('hide');
    $("#ad_price_without_vat").attr('disabled', 'disabled');
    $("#vat_rate").attr('disabled', 'disabled');
    $("#ad_price_without_vat").val($("#original_ad_price_without_vat").val());
  });

});

function adPriceWithoutVat(ad_price_without_vat, online_auction_price_list){
  var price = 0
  var selling_price = checkNumericValue(ad_price_without_vat);

  $.each(online_auction_price_list, function(index, price_list) {
    var min_price = checkNumericValue(price_list[0]);
    var max_price = checkNumericValue(price_list[1]);
    var ad_price = checkNumericValue(price_list[2]);
    
    if (min_price <= selling_price && selling_price <= max_price) {
      price = ad_price;
      return false;
    }
  });
  
  return price;
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}

function checkNumericValue(number, decimal_points = 2) {
  if (number){
    return parseFloat(parseFloat(number.toString().replace(' ', '').replace(",", ".")).toFixed(decimal_points));
  }
  else{
    return 0;
  }
}

function show_formatted_number(number, decimal_points = 2, with_space = true) {
  if (number || number === 0) {
    number = parseFloat(number).toFixed(decimal_points); // ensures decimal formatting
    var parts = number.toString().split(".");

    if (with_space) {
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    return parts.join(",");
  } else {
    return "0,00";
  }
}


function second_pagination(){
  if ($('.second_pagination').length) {
    $(document).scroll(function() {
      var url = $('.second_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.second_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }
}

function first_pagination(){
  if ($('.first_pagination').length) {
    $(document).scroll(function() {
      var url = $('.first_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.first_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }
}

function third_pagination(){
  if ($('.third_pagination').length) {
    $(document).scroll(function() {
      var url = $('.third_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.third_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }
}

